import { useState } from 'react';
import { FiTrash2, FiX } from 'react-icons/fi';
import './DeleteUserConfirmModal.css';

function DeleteUserConfirmModal({ userName, onConfirm, onCancel }) {
  const [deleting, setDeleting] = useState(false);

  const handleConfirm = async () => {
    setDeleting(true);
    await onConfirm();
  };

  return (
    <div className="delete-user-modal-overlay" onClick={deleting ? undefined : onCancel}>
      <div className="delete-user-modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="delete-user-modal-close" onClick={onCancel} disabled={deleting}>
          <FiX />
        </button>

        <div className="delete-user-modal-icon">
          <FiTrash2 />
        </div>

        <h2>Delete user?</h2>
        <p>Are you sure you want to delete <strong>{userName}</strong>? This action cannot be undone.</p>

        <div className="delete-user-modal-actions">
          <button className="delete-user-modal-cancel-btn" onClick={onCancel} disabled={deleting}>
            Cancel
          </button>
          <button className="delete-user-modal-confirm-btn" onClick={handleConfirm} disabled={deleting}>
            {deleting ? <span className="delete-user-modal-spinner" /> : 'Delete'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default DeleteUserConfirmModal;
